<div class="relative my-20">
    @if (quickTips) {
        <div
            class="gird grid-cols-1 rounded-lg border border-link-blue bg-white p-10">
            <div class="flex justify-center">
                <h3 class="mb-3 font-heading text-2xl font-bold">
                    {{ quickTips.title }}
                </h3>
            </div>
            <div class="">
                <ul
                    class="list-disc space-y-9 pl-5 marker:text-2xl marker:text-red">
                    @for (tip of quickTips.tips; track tip) {
                        <li class="font-serif text-lg text-darkgrey">
                            {{ tip }}
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
    <div
        class="absolute left-[2%] top-[-2%] z-0 h-[104%] w-[96%] rounded-lg border border-link-blue bg-transparent md:top-[-5%] md:h-[110%]"></div>
</div>
